import { render } from "./ManageBookings.vue?vue&type=template&id=2425d499&scoped=true"
import script from "./ManageBookings.vue?vue&type=script&lang=js"
export * from "./ManageBookings.vue?vue&type=script&lang=js"

import "./ManageBookings.vue?vue&type=style&index=0&id=2425d499&scoped=true&lang=css"

import exportComponent from "/home/walnit/Documents/AppVenture/nush-bookings-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2425d499"]])

export default __exports__